// plugins/facebook.js

export default ({ app }, inject) => {
    if (process.client) {
        setTimeout(() => {
            window.fbAsyncInit = function () {
                FB.init({
                    appId: process.env.FACEBOOK_CLIENT_ID || '1751738522243731', // Замените на ваш App ID
                    cookie: true,
                    xfbml: true,
                    version: 'v21.0', // Версия API Facebook
                });
                FB.AppEvents.logPageView();
            };

            (function (d, s, id) {
                var js,
                    fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s);
                js.id = id;
                js.src = 'https://connect.facebook.net/en_US/sdk.js';
                fjs.parentNode.insertBefore(js, fjs);
            })(document, 'script', 'facebook-jssdk');
        }, 5000);
    }
};
